export default function TitleDiplom() {
    return (
        <h1>Mes <span>Diplômes</span> et <span>Formations</span></h1>
    );
}